import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Sep 04, 2026 · Silence CRA's dev-overlay elevation of the benign
// "ResizeObserver loop completed with undelivered notifications"
// warning. Radix Popover width-syncs the popover to its trigger via a
// ResizeObserver — that observer fires the browser warning on the same
// tick a Radix Popover mounts / re-measures (SearchablePicker, article
// combo, customer combo, supplier combo, machine picker, …). It's a
// spec-compliant browser message, NOT a real error, so we stop it from
// propagating to CRA's `webpackHotDevClient` handler that renders the
// full-page red-overlay. Everything else (real TypeError / ReferenceError)
// still surfaces unchanged.
const _IS_RO_LOOP_MSG = (m) =>
  typeof m === "string" &&
  (m.startsWith("ResizeObserver loop") || m.includes("ResizeObserver loop completed"));
window.addEventListener("error", (e) => {
  if (_IS_RO_LOOP_MSG(e?.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);
window.addEventListener("unhandledrejection", (e) => {
  const msg = e?.reason?.message || e?.reason;
  if (_IS_RO_LOOP_MSG(msg)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Aug 2026 · Register the PWA service worker so Chrome / Edge / Samsung
// Internet mark the app "installable" and fire `beforeinstallprompt`.
// Wrapped in a feature check + try/catch — an SW failure must never
// break the actual React app.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    try {
      navigator.serviceWorker.register("/service-worker.js").catch(() => { /* offline / dev sandbox */ });
    } catch (_e) { /* ignore */ }
  });
}
